import { IWidgetCard } from '@entities/widget-card/model/types';
import { useAppDispatch, useAppSelector } from 'store';

import { getWidgetModalsState } from './selectors';
import {
    closeWidgetModal,
    openDetailsModal,
    openOnlyAdminModal,
    openPaymentModal,
} from './widgetModalsSlice';

export const useWidgetModals = () => {
    const dispatch = useAppDispatch();
    const modal = useAppSelector(getWidgetModalsState);

    const close = () => {
        dispatch(closeWidgetModal());
    };

    const openDetails = (widgetId: IWidgetCard['id']) => {
        dispatch(openDetailsModal(widgetId));
    };

    const openPayment = (widgetId: IWidgetCard['id']) => {
        dispatch(openPaymentModal(widgetId));
    };

    const openOnlyAdmin = (widgetId?: IWidgetCard['id'] | null) => {
        dispatch(openOnlyAdminModal(widgetId));
    };

    return {
        modal,
        close,
        openDetails,
        openPayment,
        openOnlyAdmin,
    };
};
